<template>
  <form role="form" @submit.prevent="onSubmit">
    <template v-if="!emailDefault">
      <app-input-text v-model="user.email" label="E-mail" c_css value />
    </template>
    <template v-else>
      <input type="hidden" v-model="user.email" />
    </template>

    <app-input-password v-model="user.pwd" label="Senha" c_css />

    <div class="text-center">
      <button type="submit" class="btn btn-primary w-100 waves-effect waves-light"
        :disabled="isSubmitButtonDisabled">Acessar</button>
    </div>
  </form>
</template>
<script>
import AppInputText from "@/components/AppInputText/AppInputText.vue";
import AppInputPassword from "@/components/AppInputPassword/AppInputPassword.vue";
import { mapActions, mapMutations } from "vuex";
import useSubmitButtonState from "@/modules/useSubmitButtonState";
import { reactive } from "vue";

export default {
  props: {
    destiny: {
      type: String,
      require: true
    },
    emailDefault: {
      type: String,
      require: false
    }
  },
  setup() {
    const user = reactive({
      pwd: "",
      email: ""
    });
    const { isSubmitButtonDisabled } = useSubmitButtonState(user);
    return { user, isSubmitButtonDisabled };
  },
  components: {
    AppInputText,
    AppInputPassword
  },
  data() {
    return {
      successMessage: "Bem-vindo(a)."
    };
  },
  created() {
    if (this.emailDefault) {
      this.user.email = this.emailDefault;
    }
  },
  methods: {
    ...mapActions([
      "showMessage",
      "showLoader",
      "setLoaderTitle",
      "showBlockScreen"
    ]),
    ...mapMutations(["setId", "setName", "setEmail", "setToken"]),
    onAction() {
      const _this = this;
      if (this.destiny === "login") {
        const path = _this.$getDataUser()
          ? _this.$getDataUser()
          : "/s/dashboard";

        setTimeout(function () {
          _this.$router.push(path).catch(err => {
            console.error("Erro na navegação:", err);
          });
        }, 2000);
      } else {
        _this.showBlockScreen(false);
        setTimeout(function () {
          _this.$router.go(_this.$router.currentRoute);
        }, 100);
      }
    },
    onLoader(val) {
      if (this.destiny === "login") {
        this.showLoader(val);
      }
    },
    async onSubmit() {
      const _this = this;
      this.onLoader(true);
      const data = { email: this.user.email, password: this.user.pwd };
      const { url, options } = this.$getAPIHeadersFetch("POST", `login`, data);
      try {
        const response = await fetch(url, options);
        const result = await response.json();

        if (result.status === 200 || result.status === 201) {
          _this.$setDataUser(result.data);
          _this.onLoader(false);
          _this.showMessage({
            title: _this.successMessage,
            css: "bg-success"
          });
          _this.onAction();
        } else if (result.status === 400) {

          this.showMessage({
            title: result.message,
            css: "bg-danger"
          });

        } else {
          console.log('result', result);
          this.showMessage({
            title: "Por favor, revise os dados fornecidos.",
            text: result.errors,
            css: "bg-danger"
          });
          
        }


      } catch (error) {
        this.showMessage({
          title: "Desculpe um erro aconteceu, por favor, tente novamente.",
          css: "bg-danger"
        });
         console.log(error);

      } finally {
        this.showLoader(false);
      }
    }
  }
};
</script>